import { TelemetryFilterState } from '@/types/enums';
import { S2Selection } from '@/types/s2selection';

export default function () {
  return [
    new S2Selection<TelemetryFilterState>('All', 'Alle', TelemetryFilterState.All, null),
    new S2Selection<TelemetryFilterState>('NoData', 'Ingen data', TelemetryFilterState.NoData, null),
    new S2Selection<TelemetryFilterState>(
      'NoDataIn24Hours',
      'Ingen data i 24 timer',
      TelemetryFilterState.NoDataIn24Hours,
      null
    ),
    new S2Selection<TelemetryFilterState>(
      'NoDataIn3Days',
      'Ingen data i 3 dage',
      TelemetryFilterState.NoDataIn3Days,
      null
    ),
    new S2Selection<TelemetryFilterState>(
      'NoDataIn1Week',
      'Ingen data i 1 uge',
      TelemetryFilterState.NoDataIn1Week,
      null
    ),
    new S2Selection<TelemetryFilterState>(
      'HaveDataIn24Hours',
      'Data indenfor 24 timer',
      TelemetryFilterState.HaveDataIn24Hours,
      null
    ),
    new S2Selection<TelemetryFilterState>(
      'HaveDataIn3Days',
      'Data indenfor 3 dage',
      TelemetryFilterState.HaveDataIn3Days,
      null
    ),
    new S2Selection<TelemetryFilterState>(
      'HaveDataIn1Week',
      'Data indenfor 1 uge',
      TelemetryFilterState.HaveDataIn1Week,
      null
    ),
    new S2Selection<TelemetryFilterState>(
      'HaveDataIn1Month',
      'Data indenfor 30 dage',
      TelemetryFilterState.HaveDataIn30Days,
      null
    )
  ];
}
